// BO-020: any form — or any single submit button — carrying data-confirm-message is held back and
// the question handed to ConfirmActionDialog through a `pc:confirm` event. Declare it on the button
// only when one form has several submit buttons with different consequences
// (CaregiverVisits/Visit.cshtml); otherwise on the form.
//
// `dialogReady` resolves once the dialog island has mounted and registered its listener: the
// interceptor is live the moment the page is interactive, the dialog only after its chunk arrives.
//
// On proceed the form is resubmitted *through the same button*, so its formaction, name and value
// survive. Returns an uninstaller; the app never calls it, the spec does after every test.
export function installConfirmInterceptor(doc, dialogReady) {
  const onSubmit = (e) => {
    const form = e.target;
    const submitter = e.submitter ?? null;
    const source = submitter?.dataset.confirmMessage ? submitter : form;
    const message = source.dataset.confirmMessage;
    if (!message) return;
    if (form._confirmed) return;
    e.preventDefault();
    dialogReady.then(() => {
      doc.dispatchEvent(new CustomEvent("pc:confirm", {
        detail: {
          message,
          labelOk: source.dataset.confirmOk,
          labelCancel: source.dataset.confirmCancel,
          // requestSubmit dispatches the submit event synchronously, so the flag lives exactly as long as
          // that one resubmission, and is cleared even when requestSubmit throws or the form fails validation
          // and fires no event — otherwise the next click would post without asking.
          proceed: () => {
            form._confirmed = true;
            try { form.requestSubmit(submitter); } finally { form._confirmed = false; }
          },
        },
      }));
    });
  };
  doc.addEventListener("submit", onSubmit, true);
  return () => doc.removeEventListener("submit", onSubmit, true);
}
